import { DataPoint, DataPointTreeBranch } from 'src/pages/SignInPage/_BLL/types';

export const isDataPointTreeLeaf = (leaf: DataPointTreeBranch | DataPoint): leaf is DataPoint => {
	return (leaf as DataPoint).datapointId !== undefined;
};
